module.exports = __webpack_public_path__ + "static/media/icon_lock_qna.b3575689.svg";